import { connect } from 'react-redux'
import UpdateGroup from './update-group'
import { isOpen, getId } from './update-group.selectors'
import { closeUpdateGroupDialog } from './update-group.actions'
import { getGroup } from '../../../../../stores/groups/groups.selectors'
import { updateGroup } from '../../../../../stores/groups/groups.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const group = getGroup(state, getId(state))
  const opened = isOpen(state)
  if (!group) return { opened }
  return {
    editableProps: group.policy.editable_properties,
    opened,
    id: group.id,
    title: group.title,
    visibility: group.visibility
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  requestClose: () => dispatch(closeUpdateGroupDialog()),
  onSubmit: ({ groupTitle, groupVisibility }) => {
    const params = {
      title: groupTitle,
      visibility: groupVisibility
    }
    return dispatch(
      updateGroup(
        stateProps.id,
        !stateProps.mis
          ? params
          : {
              visibility: groupVisibility
            }
      )
    ).catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(UpdateGroup)
